// extracted by mini-css-extract-plugin
export default {"wrapper":"VehicleBreadcrumb_wrapper__vpHpD"};